import { gql } from "@apollo/client";

export const ALL_CLASSROOMS_FOR_TEACHER = gql`
query allClassroom {
  allClassrooms(condition: { deletedAt: null }, orderBy: C_NAME_ASC) {
    nodes {
      cName
      cOriginalName
      cId
    }
  }
}
`;

export const VERIFY_PASS_CODE = gql`
mutation verifyCode($input: verifyCodeInput!) {
  verifyClassroomCode(input: $input) {
    message
  }
}
`;
